<label *ngIf="showTodos">
  <input *ngIf="!isReadOnly" type="checkbox" [(ngModel)]="pedidoClienteSelected.todos"
         (change)="changePedidoClienteSelectedTodos()" />
  {{ SITE.labelCliente }}
</label>
<br />

<div *ngFor="let pc of pedido.clientes">
  <label style="font-size: inherit">
    <input *ngIf="!isReadOnly" type="checkbox" [(ngModel)]="pedidoClienteSelected[pc.cliente.id]"
           (change)="changePedidoClienteSelected()" />
    {{ pc.cliente[SITE.identificacaoCliente] }} - {{ pc.cliente.nome }}
  </label>

  <a *ngIf="pedido.tipo.aprovacaoCliente"
     (click)="getLinkAprovaCliente(pc.id)"
     style="cursor: pointer">
    <span *ngIf="pc.aprovado; else elseBlockAprvCli" style="color: green">
      &nbsp;<b><u>APROVADO</u></b>
    </span>
    <ng-template #elseBlockAprvCli>
      <span style="color: orange">&nbsp;<b><u>AGUARDANDO</u></b></span>
    </ng-template>
  </a>
</div>
  